import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-02405dd5")

_pushScopeId("data-v-02405dd5")
const _hoisted_1 = { class: "page-tab" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.pageTitle, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: { 'only-title': !!item.isActive }
      }, [
        _createVNode("span", {
          onClick: ($event: any) => ($setup.hanldActive(index))
        }, _toDisplayString(item.text), 9, ["onClick"])
      ], 2))
    }), 128))
  ]))
})